export const MAX_POP_SCORE_FOR_REVIEW_OPTIMIZATION = 75
